import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { ConfigApi, UserApi } from '../core/constants/api.constant';
import { BaseService } from '../core/services/base.service';

@Injectable({
  providedIn: 'root'
})
export class CommonService extends BaseService {

  rejectedRequestChanged$: Subject<any> = new Subject<any>();
  rejectedRequest = new Subject<any>();
  
  constructor(protected http: HttpClient) {
    super(http);
  }
 
  setDefaultAccount(reqPayload) {
    const url = super.serviceUrl(this.apiConfig.user, ConfigApi.DefaultAccount);
    return super.post(url, reqPayload).pipe(map((response: any) => {
      return response;
    }));
  }

  sendSuggestion(reqPayload) {
    const url = super.serviceUrl(this.apiConfig.user, ConfigApi.Suggestion);
    return super.post(url, reqPayload).pipe(map((response: any) => {
      return response;
    }));
  }

  changeSecurityQuestion(userEmail)
  {
    const url = super.serviceUrl(this.apiConfig.login, UserApi.SecurityQuestion+userEmail);
    return url;
  }

}
